const urlStart = 'https://pluit-backend.smartclaimsystem.com';
const baseImage = 'https://pluit-backend.smartclaimsystem.com/api/image';
//const urlStart = 'https://backend.autoprima.co.id';
//const baseImage = 'https://backend.autoprima.co.id';
const productionMode = true;
const awsImageUploader = '';

const workorderOptions = {
    allowTutupWoStepBengkel : true // Kalo Tutup Work Order Tidak Ad Kondisi Step Bengkel Hrus Semua Selesai , Set ini True
}


export default {productionMode , urlStart, baseImage : baseImage ? baseImage : urlStart , awsImageUploader, workorderOptions};
